import React from "react";
import PropTypes from "prop-types";
import BaseComponent from "../../../../../../base/BaseComponent";

/**
 * 选择用户
 */
class UserSelect extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: "",
            belongDeptId: "",
            userData: []
        };
    }


    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        // 用于  用户回显、通过部门Id请求用户数据
        const {fieldProps} = this.props;
        if (fieldProps.belongDeptId) {
            this.setState({
                value: fieldProps.value,
                belongDeptId: fieldProps.belongDeptId,
            }, () => {
                this.getDeptUser(fieldProps.belongDeptId)
            })
        }
    }

    //用于  每次改变所属部门的  用户回显、请求用户数据
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {fieldProps} = this.props;
        if (prevProps.fieldProps.belongDeptId !== fieldProps.belongDeptId) {
            this.setState({
                value: "",
                belongDeptId: fieldProps.belongDeptId,
            }, () => {
                fieldProps.onChange(this.state.value);
                this.getDeptUser(fieldProps.belongDeptId)
            })
        }
    }

    getDeptUser(deptId) {
        this.request({
            url: "/cm-sites-sys/user/getUserByDeptId?deptId=" + deptId,
            body: {},
            method: "get",
            callBack: (res) => {
                let userData = [];
                if (res && res.length) {
                    userData = res;
                }
                this.setState({
                    userData
                })
            }
        })
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(UserSelect.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if (Array.isArray(props.fieldProps?.extra) && !props.fieldProps?.extra.includes(fieldKey)) {
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }

    render() {
        const {value, userData} = this.state;
        const userName = userData && userData.find(item => item.id === value)?.name;
        return (
            <div className={"position-manage-detail-value"}>
                {userName}
            </div>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        } else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}

export default UserSelect;

UserSelect.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

UserSelect.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {
        options: [],
    },
}